"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports["default"] = void 0;
var _types = require("../../actions/types");
var _underscore = _interopRequireDefault(require("underscore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = exports.initialState = {};
// sample state for attendeeVoiceIntensity
// {
//   "af9404a7-da50-1827-e742-ceea5792837c": 0.1,
//   "cfb698a7-da50-18ad-e742-ceea5792837d": 0.7,
// }

//Check if a redux state update is required or not
var checkStateUpdateRequired = function checkStateUpdateRequired(oldState, payload) {
  if (Object.keys(oldState).length != Object.keys(payload).length) {
    return true;
  }
  return !_underscore["default"].every(_underscore["default"].keys(oldState), function (currentKey) {
    return _underscore["default"].has(payload, currentKey) && _underscore["default"].isEqual(oldState[currentKey], payload[currentKey]);
  });
};
function attendeeVoiceIntensity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload,
    type = action.type;
  if (type === _types.SET_ATTENDEE_VOICE_INTENSITY && checkStateUpdateRequired(state, payload)) {
    return _objectSpread(_objectSpread({}, state), payload);
  }
  return state;
}
var _default = exports["default"] = attendeeVoiceIntensity;